document.addEventListener('DOMContentLoaded', function () {
  const videoBox = document.querySelector('.elevance-video');
  if (!videoBox) return;

  const btn = videoBox.querySelector('.elevance-play-btn');
  const thumb = videoBox.querySelector('.elevance-video-thumb');

  let videoCreated = false;
  let video;

  btn.addEventListener('click', function () {
    if (!videoCreated) {
      const videoUrl = videoBox.dataset.videoUrl;

      video = document.createElement('video');
      video.className = 'elevance-video-player';
      video.setAttribute('controls', '');
      video.setAttribute('playsinline', '');
      video.style.width = '100%';
      video.style.aspectRatio = '16/9';

      const source = document.createElement('source');
      source.src = videoUrl;
      source.type = 'video/mp4';

      video.appendChild(source);
      videoBox.appendChild(video);

      videoCreated = true;

      video.addEventListener('ended', resetVideo);
      video.addEventListener('pause', function () {
        if (video.currentTime > 0 && !video.ended) {
          resetVideo();
        }
      });
    }

    thumb.style.display = 'none';
    btn.style.display = 'none';
    video.style.display = 'block';

    video.play();
  });

  function resetVideo() {
    video.pause();
    video.currentTime = 0;

    video.style.display = 'none';
    thumb.style.display = 'block';
    btn.style.display = 'flex';
  }
 });

